import { environment } from '../../../environments/environment';
import { HomeFaq } from '../../pages/home/faq-section/faq-section.component';

/**
 * Plan prices for JSON-LD. Mirrors pricing-table.component.ts
 * (Society $299/mo, Growth $599/mo, Operator from $1,500/mo) — keep in sync.
 */
export const PRICING_TIERS = [
  { name: 'Society', price: 299, minPrice: false },
  { name: 'Growth', price: 599, minPrice: false },
  { name: 'Operator', price: 1500, minPrice: true }
];

export function organizationJsonLd(siteUrl = environment.siteUrl): Record<string, unknown> {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'MemberTrace',
    url: `${siteUrl}/`,
    logo: `${siteUrl}/img/membertrace-logo-color.png`
  };
}

export function softwareApplicationJsonLd(siteUrl = environment.siteUrl): Record<string, unknown> {
  return {
    '@context': 'https://schema.org',
    '@type': 'SoftwareApplication',
    name: 'MemberTrace',
    applicationCategory: 'BusinessApplication',
    operatingSystem: 'Web, iOS',
    url: `${siteUrl}/`,
    offers: PRICING_TIERS.map((tier) => ({
      '@type': 'Offer',
      name: tier.name,
      priceCurrency: 'USD',
      url: `${siteUrl}/pricing`,
      priceSpecification: {
        '@type': 'UnitPriceSpecification',
        priceCurrency: 'USD',
        unitText: 'MONTH',
        ...(tier.minPrice ? { minPrice: tier.price } : { price: tier.price })
      },
      ...(tier.minPrice ? {} : { price: tier.price })
    }))
  };
}

export function faqPageJsonLd(faqs: HomeFaq[]): Record<string, unknown> {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: { '@type': 'Answer', text: faq.answer }
    }))
  };
}
